import { render } from "./LayerTwo.vue?vue&type=template&id=fba79e14&scoped=true&ts=true"
import script from "./LayerTwo.vue?vue&type=script&lang=ts"
export * from "./LayerTwo.vue?vue&type=script&lang=ts"

import "./LayerTwo.vue?vue&type=style&index=0&id=fba79e14&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba79e14"]])

export default __exports__